import React, { Component, PropTypes } from "react"
import { Field, reduxForm } from "redux-form"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { updateAccount } from "../actions"
import { Col, Panel, Row, Alert } from 'react-bootstrap'
import Geosuggest from 'react-geosuggest';
import _ from 'lodash'
import axios from 'axios'
import RendererWithGoogleMap from './google_map'
import Demo from './getgeolocation'
import NavHeader from './navheader'
import SubMenu from './submenu'
import Footer from './footer'
class Address extends Component {
    state = {
        showgeoaddress: "",
        lat: 0,
        lng: 0,
        deflat: 13.896995,
        deflng: 100.6064463,
        allowgetlocation: true,
        loading: false,
        addressString: '',
        house_number: '',
        road: '',
        landmark: '',
        confirmAddress: false,
        residential_type: '',
    }
    onSuggestSelect(suggest) {
        this.setlocation(suggest.location.lat, suggest.location.lng)
        this.setdefaultlocation(suggest.location.lat, suggest.location.lng)
    }
    setcentermap(lat, lng) {
        //console.log("CENLAT",lat,"CENLNG",lng)
        //this.getlocationaddress(lat, lng)
        this.setState({
            deflat: lat,
            deflng: lng
        })
    }
    setlocation(lat, lng) {
        //console.log("LAT",lat,"LNG",lng)
        this.getlocationaddress(lat, lng)
        this.setState({
            lat: lat,
            lng: lng
        })
    }
    setdefaultlocation(deflat, deflng) {
        //console.log("DEFLAT",deflat,"DEFLNG",deflng)
        //this.getlocationaddress(deflat, deflng)
        //this.getdistance(deflat, deflng)
        this.setState({ allowgetlocation: false })
        this.setState({
            deflat: deflat,
            deflng: deflng
        })
    }
    getlocationaddress(deflat, deflng) {
        this.setState({ confirmAddress: false })
        const googlemapAPIUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${deflat},${deflng}&sensor=true&language=th&key=AIzaSyAqSHcwRu_Rqy1ff7mUIK-8Zkxv_nOtU5I`
        var self = this;
        axios
            .get(googlemapAPIUrl)
            .then(function (result) {
                if (result != null) {
                    // console.log(result)
                    let district, area, province, zip_code

                    result.data.results.forEach(data2 => {
                        data2.address_components.forEach(data => {
                            switch (data.types[0]) {
                                case 'political':
                                    if (data.types[2] === 'sublocality_level_1') {
                                        area = data.long_name
                                    } else {
                                        district = data.long_name
                                    }
                                    break
                                case 'administrative_area_level_1':
                                    province = data.long_name
                                    break
                                case 'postal_code':
                                    zip_code = data.long_name
                                    break
                                default:
                            }
                        })
                    })

                    self.setState({
                        addressString: result.data.results[0].formatted_address,
                        district: district ? district.split(' ')[1] : 'แขวง',
                        area: area ? area.split(' ')[1] : 'เขต',
                        province: province,
                        zip_code: zip_code,
                    })
                }
            })
            .catch(function (error) {
                console.log(error)
                // console.log("ERROR", "ไม่สามารถดึงค่าที่อยู่ได้");
            })
    }
    checkismapinaccuracy(postal_code, gmappostal_code) {
        if (!(postal_code == gmappostal_code)) {
            this.setState({ ismapinaccuracy: true })
        } else {
            this.setState({ ismapinaccuracy: false })
        }
    }
    onSubmit() {
        if (!this.state.addressString || !this.state.house_number || !this.state.road) {
            window.alert('กรุณากรอกข้อมูลให้ครบ')
        } else {
            let user = JSON.parse(localStorage.getItem('user'))
            user.address = {}
            user.address.address1 = {
                latitude: this.state.lat,
                longitude: this.state.lng,
                house_number: this.state.house_number,
                road: this.state.road,
                district: this.state.district,
                area: this.state.area,
                province: this.state.province,
                zip_code: this.state.zip_code,
                landmark: this.state.landmark,
                residential_type: this.state.residential_type,
            }
            this.setState({ loading: true })
            this.props.updateAccount(user, user.token).then(response => {
                if (response.payload.status == 200) {
                    this.props.history.push('/confirm_address')
                }
            })
            localStorage.setItem('user', JSON.stringify(user))
        }
    }
    render() {
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className='container main-bg'>
                    {/* desktop */}
                    <div style={{ padding: 15 }} >
                        <Geosuggest
                            inputClassName='form-control'
                            placeholder="ค้นหาที่อยู่"
                            ignoreTab={true}
                            minLength={2}
                            suggestsClassName="form-control"
                            suggestItemClassName="autosuggest"
                            onSuggestSelect={(e) => { this.onSuggestSelect(e) }}
                        />
                    </div>

                    {/* <div style={{ paddingLeft: 15, paddingRight: 15 }}>
                        <button type='button' style={{ width: '100%' }} className="btn btn-primary" onClick={() => { this.setState({ allowgetlocation: true, clicked: true }) }}>ใช้ตำแหน่งปัจจุบัน<span style={{ fontSize: 20 }} className='fa fa-map-marker hidden-xs'></span></button>
                    </div> */}

                    {/* map */}
                    <div style={{ padding: 15 }}>
                        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                            {(this.state.allowgetlocation == true
                                ? <Demo
                                    setdefaultlocation={this.setdefaultlocation.bind(this)}
                                    setlocation={this.setlocation.bind(this)}
                                />
                                : null
                            )}
                        </div>
                        <RendererWithGoogleMap
                            setlocation={this.setlocation.bind(this)}
                            setcentermap={this.setcentermap.bind(this)}
                            containerElement={<div style={{ width: 'auto', height: 400 }} />}
                            mapElement={<div style={{ width: 'auto', height: 400 }} />}
                            loadingElement={'<div className="loader">กำลังโหลด</div>'}
                            markers={[
                                {
                                    position: { lat: this.state.lat, lng: this.state.lng },
                                    title: "ลากหมุดเพื่อเลือกที่ิอยู่",
                                    draggable: true,
                                }
                            ]}
                            defaultCenter={{ lat: this.state.deflat, lng: this.state.deflng }}
                            center={{ lat: this.state.deflat, lng: this.state.deflng }}
                            onMapLoad={(elm) => (this.map = elm)}
                            zoom={15}
                            disableDefaultUI={true}
                            streetViewControl={false}
                        //googleMapApiKey='AIzaSyD4S-fj4TDa3hdJcG2Pw74GP782qbM26kU'
                        //googleMapUrl="https://maps.googleapis.com/maps/api/js?v=3&libraries=places&key="
                        />
                    </div>

                    {
                        !this.state.confirmAddress ?
                            <div style={{ padding: 15 }}>
                                <button type='button' onClick={() => { this.setState({ confirmAddress: true }) }} style={{ width: '100%' }} className="btn btn-success">ยืนยันตำแหน่ง</button>
                            </div>
                            : ''
                    }

                    {/* detail */}
                    {
                        this.state.confirmAddress ?
                            <div>
                                <div style={{ padding: '0px 15px 0px 15px' }}>
                                    <input value={this.state.house_number} onChange={(e) => { this.setState({ house_number: e.target.value }) }} placeholder='เลขที่*' style={{ display: 'inline-block', width: 'auto', marginRight: 15, marginBottom: 15 }} className='form-control' />
                                    <input value={this.state.residential_type} onChange={(e) => { this.setState({ residential_type: e.target.value }) }} placeholder='ชื่ออาคาร/หมู่บ้าน' style={{ display: 'inline-block', width: 'auto', marginRight: 15, marginBottom: 15 }} className='form-control' />
                                    <input value={this.state.road} onChange={(e) => { this.setState({ road: e.target.value }) }} placeholder='ถนน*' style={{ display: 'inline-block', width: 'auto', marginRight: 15, marginBottom: 15 }} className='form-control' />
                                    <h5 style={{ display: 'inline-block' }}>{this.state.addressString}</h5>
                                </div>
                                <div style={{ padding: '0px 15px 0px 15px' }}>
                                    <label>จุดสังเกต: &nbsp;</label>
                                    <textarea row='2' value={this.state.landmark} onChange={(e) => { this.setState({ landmark: e.target.value }) }} placeholder='จุดสังเกต' style={{ width: '100%', marginBottom: 15 }} className='form-control' />
                                </div>
                                <div>
                                    <button disabled={this.state.loading} type='button' onClick={() => { this.onSubmit() }} style={{ marginRight: 30, marginBottom: 30 }} className="btn btn-primary pull-right">เสร็จสิ้น</button>
                                </div>
                            </div>
                            : ''
                    }
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }
}
export default connect(null, { updateAccount })(Address)


// WEBPACK FOOTER //
// ./src/components/component_address_new.js